// NOTE: This file should be used for exports only
import { withSuspense } from 'components/Decorators';
import { lazy } from 'react';
import { withColorScheme } from 'redesignedComponents/decorators/withColorScheme';
import Fallback from './BannerBlock.fallback';
import { BannerBlockProps } from './types';

export type { BannerBlockProps } from './types';

export { default as testIds } from './testIds';

export default withSuspense(
  withColorScheme<BannerBlockProps>(lazy(() => import('./BannerBlock'))),
  Fallback,
);
